module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-600.woff?449d681cd6006390e1bee3c3a660430b";